import { ListPharmacyReturn } from "@/api/types";

// only "never" pharmacies lead the cards; far away "check" pharmacies keep the API's lookup rule order
export const orderPharmaciesForCards = (results: ListPharmacyReturn["results"]): ListPharmacyReturn["results"] => {
  const pharmacies = results || [];
  const isNeverOnMap = (p: (typeof pharmacies)[number]) => p.pharmacy.pharmacy_display_rules?.display_on_map === "never";

  return pharmacies.filter(isNeverOnMap).concat(pharmacies.filter((p) => !isNeverOnMap(p)));
};
